"use client";

import { Button } from "@gogive/design-system";
import type { ComponentProps } from "react";

/** Compact actions for the shell top bar (h-10). */
export function TopBarButton({
  size = "sm",
  variant = "outline",
  ...props
}: ComponentProps<typeof Button>) {
  return <Button size={size} variant={variant} {...props} />;
}
